import { TargetDomainFormFieldHandler } from '../components/TargetDomainForm';
import { useFieldCreateNewTargetDomain } from './useFieldCreateNewTargetDomain';

// eslint-disable-next-line import/prefer-default-export
export function useFieldCreateNew(
  handleFieldUpdate: TargetDomainFormFieldHandler,
): [TargetDomainFormFieldHandler] {
  const [handleFieldTargetDomain] = useFieldCreateNewTargetDomain(handleFieldUpdate);

  const handleFieldCreateNew: TargetDomainFormFieldHandler = (
    param,
    formSection,
  ) => {
    const { name } = param;

    if (name === 'domain') {
      handleFieldTargetDomain(param, formSection);
    }
  };

  return [handleFieldCreateNew];
}
